/**
 * @ Author: Housefolios
 * @ Create Time: 2021-11-24 19:59:53
 * @ Modified by: Daniel Clark
 * @ Modified time: 2025-02-04 11:56:40
 * @ Description: List of options to filter seen assumptions by.
 */

import React from 'react'
// Centralized lodash imports - much cleaner!
import {
  map,
  filter as lodashFilter,
  includes,
  pull} from '@/utils/lodash'

import {Grid, Card, CardContent, Checkbox, Divider, FormControlLabel,  MenuItem, TextField, Box } from '@mui/material'
import { getStrategyOptions } from '@/utils/stratagies'

export default function AssumptionsFilter(props) {
  const { filter, setFilter } = props

  // function handleChange(value) {
  //   let newFilters = [...filters]
  //   if (includes(newFilters, value))
  //     pull(newFilters, value)
  //   else
  //     newFilters.push(value)
  //   setFilters(newFilters)
  // }

  return (
    <Card style={{ width: '100%' }}>
      <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
        <Box sx={{
          flexGrow: 1,
          minWidth: 0,
          "& > b": { display: "block" },
          "& > small": {
            textTransform: "uppercase",
            display: "block",
            opacity: 0.3,
            fontWeight: "bold",
          },
        }}>
          <b>
            {props.targetOnly
              ? 'Show Targets For'
              : 'Show Assumptions For'}
          </b>
        </Box>
      </div>
      <Divider />
      <CardContent>
        <Grid
          container
          direction="row"
          style={{ width: '100%' }}
          sx={{
            justifyContent: "flex-start",
            alignItems: "center"
          }}>
          {/* {map(filterOptions, section => (
            <Grid size={{xs: 6, md: 12, xl: 6}} key={section.label}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={includes(filters, section.label)}
                    onChange={() => handleChange(section.label)}
                    value="checked1"
                    color="primary"
                  />
                }
                label={section.label}
              />
            </Grid>
          ))} */}
          <Grid style={{ width: '100%' }}>
            <TextField
              select
              variant="outlined"
              margin="dense"
              label="Assumptions Filter"
              fullWidth={true}
              style={{ minWidth: 175 }}
              value={filter}
              onChange={(event) => setFilter(event.target.value)}
              required={true}
            >
              {getStrategyOptions(props.member)}
            </TextField>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
